import "./index.css";
import "./i18n";

import { createRoot } from "react-dom/client";

import App from "./App.tsx";

// Capture the prompt event as early as possible
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  (window as any).deferredPrompt = e;
});

createRoot(document.getElementById("root")!).render(<App />);
